import React, {useEffect, useRef, useState} from 'react';
import {withRouter} from "../../../../utils/services/with-router";
import {connect} from "react-redux";
import ProductCard from "../../../../shared/components/productCard/ProductCard";
import RequestCard from "./sentRequestCard";
import {Flex, Skeleton} from "antd";
import {getReceivedBorrowRequest, getSentBorrowRequest} from "../../actions/Cartable.action";
import {RequestListProps} from "../../models/RequestListProps";
import moment from 'jalali-moment';
import {useParams} from "react-router-dom";
import BorrowRequestPopup from "../borrowRequestPoup/BorrowRequestPopup";
import {SentRequestListProps} from "../../models";
import {EmptyMessage} from "../../../../shared";

const SentRequestList = ({getSentBorrowRequest}:SentRequestListProps) => {
    const [openPopup, setOpenPopup] = useState<boolean>(false)
    const [clickedCardData, setClickedCardData] = useState<any>()
    const [loading, setLoading] = useState<boolean>(false)

    const [requests, setRequests] = useState<any>([])
    const { requestId } = useParams(); // Get the ID from the URL
    const itemRefs = useRef<Record<string, HTMLDivElement | null>>({});

    // Scroll to the item after data is loaded
    useEffect(() => {
        if (requestId && itemRefs.current[requestId]) {
            // @ts-ignore
            itemRefs.current[requestId].scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, [requestId, requests]);
    const _getBorrowRequest = () => {
        setLoading(true);
        getSentBorrowRequest()
            .then((data: any) => {
                setLoading(false);
                if (data.payload != undefined) {
                    setRequests(data.payload.data);
                }
            })
            .catch((e: any) => {
            });
    };
    useEffect(() => {
        _getBorrowRequest()
    }, []);
    const onCansel = () => {
        console.log('dawdwada')
        setOpenPopup(false)
    }

    return (
     <Flex gap={"small"} vertical>
         {(requests?.length === 0 && !loading) && <EmptyMessage message={"درخواستی در حال حاضر موجود نیست !"}/>}

         {loading ?<Flex vertical >
                 <Skeleton round active avatar={{shape: "square" }} />
                 <Skeleton round active avatar={{shape: "square"}} />
                 <Skeleton round active avatar={{shape: "square"}} />
             </Flex> :
             requests.map((item: any) =>
                 <div key={item.id}
                      ref={(el) => (itemRefs.current[item.id] = el)}>
                     <RequestCard onCardClickHandle={(data:any) => {
                         setClickedCardData(data)
                         setOpenPopup(true)
                     }} data={item}/>
                 </div>
             )
         }
          {openPopup && <BorrowRequestPopup data={clickedCardData} open={openPopup} onCanselHandel={() => onCansel()}/>}
     </Flex>
    );
};


export default connect(null, {getSentBorrowRequest})(
    withRouter(SentRequestList)
);
